import Swal from 'sweetalert2';

const MidiaLabsSwal = Swal.mixin({
  scrollbarPadding: false,
});

export default MidiaLabsSwal;
